@if (activeMarket) {
    <div class="tree-market" [ngClass]="{ lockedmarket: this.activeMarket && !this.activeMarket.online }">
        <div class="mainmarket">
            @if (this.display3way) {
                <ms-three-way-market [event]="event" [activeMarket]="activeMarket" [tracking]="trackingSource"></ms-three-way-market>
            }
            @if (this.displayVerticalList) {
                <ms-vertical-market-list [event]="event" [activeMarket]="activeMarket" [tracking]="trackingSource"></ms-vertical-market-list>
            }
            @if (this.isMainMarketLocked) {
                <div class="market-options">
                    <div class="locked-markets">
                        <vn-icon class="tree-item-locked" size="14" [name]="isEpcotEnabled ? 'theme-locked' : 'theme-locked-i'"></vn-icon>
                    </div>
                </div>
            }
        </div>
    </div>
}
